import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = (_, { palette = {} }) => ({
  InfoMessageBar: {
    background: palette.themeLighterAlt,
  },
});

export const SystemErrorAlertForBrandLists = () => {
  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.error}
      className={classNames('error-msg-bar', 'system-error-alert')}
    >
      {i18n.getString(_TL_('We cannot load your brand lists at this time. Please try again later.'))}
    </MessageBar>
  );
};

export const MaxSelectionAlertForBrandLists = ({ selectedOptionsLimit }) => {
  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.warning}
      className={classNames('warning-msg-bar', 'max-selection-alert')}
    >
      {i18n.getString(_TL_('You can only add up to {{selectedOptionsLimit}} brand lists per campaign. Please review your selections and try again.'), { selectedOptionsLimit })}
    </MessageBar>
  );
};

MaxSelectionAlertForBrandLists.propTypes = {
  selectedOptionsLimit: PropTypes.number.isRequired,
};

export const NoInitialDataAlertForBrandLists = ({ noInitialDataText }) => {
  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.warning}
      className={classNames('info-msg-bar', 'no-inital-data-alert')}
    >
      {noInitialDataText || i18n.getString(_TL_('Create a brand list so that your ads won’t serve on search queries that mention those brands.'))}
    </MessageBar>
  );
};

NoInitialDataAlertForBrandLists.propTypes = {
  noInitialDataText: PropTypes.string,
};

NoInitialDataAlertForBrandLists.defaultProps = {
  noInitialDataText: undefined,
};

export const SystemErrorAlertForBrands = () => {
  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.error}
      className={classNames('error-msg-bar', 'system-error-alert')}
    >
      {i18n.getString(_TL_('We cannot load your brands at this time. Please try again later.'))}
    </MessageBar>
  );
};

export const MaxSelectionAlertForBrands = ({ selectedOptionsLimit }) => {
  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={MessageBarType.warning}
      className={classNames('warning-msg-bar', 'max-selection-alert')}
    >
      <ReactTemplate
        model={{
          selectedOptionsLimit,
        }}
        template={i18n.getString(_TL_('You can only add up to {{selectedOptionsLimit}} brands per brand list. Please review your selections and try again.'), { selectedOptionsLimit })}
      />
    </MessageBar>
  );
};

MaxSelectionAlertForBrands.propTypes = {
  selectedOptionsLimit: PropTypes.number.isRequired,
};

export const MoreOptionsInlineAlertForBrands = ({ optionsLimit }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <MessageBar
      messageBarType={MessageBarType.info}
      className={classNames(classes.InfoMessageBar, 'info-msg-bar', 'more-options-alert')}
    >
      {i18n.getString(_TL_('We only display the first {{optionsLimit}} brands. Please refine your search.'), { optionsLimit })}
    </MessageBar>
  );
};

MoreOptionsInlineAlertForBrands.propTypes = {
  optionsLimit: PropTypes.number.isRequired,
};

